import { createRouter, createWebHistory, RouteComponent, RouteRecordRaw } from "vue-router";

import { showPaymentHistory } from "@/common/showPaymentHistory";
import { reloadSubscriberInfo } from "@/common/reloadSubscriberInfo";
import { logEvent } from "@/common/logger";
const Home = () => import("@/components/Home/HomeRoute.vue");
const CreateAccount = () => import("@/components/Account/create/CreateAccountRoute.vue");
const BackupRoute = () => import("@/components/Backup/BackupRoute.vue");
const Backup = () => import("@/components/Backup/Backup.vue");
const Downloads = () => import("@/components/Downloads/DownloadsRoute.vue");
const PersonalInformationRoute = () => import("@/components/PersonalInformation/PersonalInformationRoute.vue");
const PersonalInformation = () => import("@/components/PersonalInformation/PersonalInformation.vue");
const AddCreditCardFromPersonalInfo = () =>
  import("@/components/PersonalInformation/AddCreditCardFromPersonalInfo.vue");
const SubscriptionInformation = () => import("@/components/Subscriptions/SubscriptionsRoute.vue");
const PaymentHistory = () => import("@/components/payment/PaymentRoute.vue");
const AccountSetup = () => import("@/components/Account/setup/AccountSetupRoute.vue");
const GetFiles = () => import("@/components/Backup/GetFilesRoute.vue");
const GetFilesCdlp = () => import("@/components/Backup/GetFilesCdlp.vue");
const DownloadWebrootTotalProtection = () => import("@/components/Backup/DownloadWebrootTotalProtection.vue");
const CreditCard = () => import("@/components/CreditCards/CreditCardRoute.vue");
const AddCreditCard = () => import("@/components/CreditCards/AddCreditCardRoute.vue");
const Support = () => import("@/components/support/SupportRoute.vue");
const EmailVerification = () => import("@/components/Account/email/EmailVerificationRoute.vue");
const EmailVerificationIncomplete = () => import("@/components/Account/email/EmailVerificationNotCompleteRoute.vue");
const FileAccess = () => import("@/components/FileAccess/FileAccessRoute.vue");
const Courier = () => import("@/components/courier/CourierRoute.vue");
const CourierRecovery = () => import("@/components/courier/CourierRecoveryRoute.vue");
const Security = () => import("@/components/Security/SecurityRoute.vue");
const Error = () => import("@/components/error/ErrorRoute.vue");
const Unknown = () => import("./Unknown.vue");
const AllstateSignUp = () => import("@/components/Allstate/AllstateRoute.vue");
const CssbRfa = () => import("@/components/FileAccess/FileAccessCSSBRoute.vue");
const CssbDownloadWatcher = () => import("@/components/FileAccess/CssbDownloadWatcherRoute.vue");
const InstallationInstructions = () =>
  import("@/components/Buy/OrderConfirmation/CarboniteInstallationInstructions.vue");
const Buy = () => import("@/components/Buy/BuyRoute.vue");
const SelectPlan = () => import("@/components/Buy/SelectPlanRoute.vue");
const FinalizeAccount = () => import("@/components/Buy/FinalizeAccountRoute.vue");
const OrderConfirmation = () => import("@/components/Buy/OrderConfirmation/OrderConfirmationRoute.vue");
const SetNewUserPassword = () =>
  import("@/components/Account/CreateNtp/SetNewUserPassword/SetNewUserPasswordRoute.vue");
const PayPal = () => import("@/components/PayPal/PayPalRedirectRoute.vue");
const BuyErrors = () => import("@/components/Buy/Errors/BuyErrorsRoute.vue");
const FlatRateOfferMismatch = () => import("@/components/Buy/Errors/FlatRateOfferMismatch.vue");
const FlatRateExpiredLicense = () => import("@/components/Buy/Errors/FlatRateExpiredLicense.vue");
const FlatRateRemainingDaysInvalid = () => import("@/components/Buy/Errors/FlatRateRemainingDaysInvalid.vue");
const WindowsArmInfo = () => import("@/components/shared/WindowsArmInfo.vue");
const SafeLongExpiredComputer = () => import("@/components/Buy/Errors/SafeLongExpiredComputer.vue");
const OptOutTrialPurchaseNotAllowed = () => import("@/components/Buy/Errors/OptOutTrialPurchaseNotAllowed.vue");
const UpgradeNotAllowed = () => import("@/components/Buy/Errors/UpgradeNotAllowed.vue");
const UnderMaintenance = () => import("@/components/UnderMaintenance/UnderMaintenanceRoute.vue");
const Invoice = () => import("@/components/Invoice/InvoiceRoute.vue");
const RenewCuidAlreadyPresentForWtpComponent = () =>
  import("@/components/Buy/Errors/RenewCuidAlreadyPresentForWtp.vue");
const CreateAolAccountRoute = () => import("@/components/Aol/CreateAolAccountRoute.vue");
const BuyBase = () => import("@/components/BuyEnhancedCart/BuyBase.vue");
const MigrateSubscription1xTo2x = () => import("@/components/Backup/Migration1xTo2x/MigrateSubscription1xTo2x.vue");

const OcpTest = () => import("@/components/OcpTest/OcpTest.vue");

import { FLAGS } from "@/define";
import { removePendoToolTip } from "@/common/pendo";

export interface IRouteMetadata {
  requireAuth?: boolean;
  hideSidebar?: boolean;
  hideTitlebar?: boolean;
  hideFooter?: boolean;
  hideProgressbar?: boolean;
}

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "root",
    component: Unknown as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/home",
    name: "home",
    component: Home as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/createAccount",
    name: "create_account",
    component: CreateAccount as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
      page_type: "user_form",
    },
  },
  {
    path: "/accountSetup/:skipLoginLogic",
    name: "account_setup",
    component: AccountSetup as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: true,
      page_type: "user_form",
    },
  },
  {
    path: "/installationInstructions",
    name: "installation_instructions",
    component: InstallationInstructions as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/getFiles",
    name: "get_files",
    component: GetFiles as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: false,
      requireAuth: true,
      parent: "backup",
    },
  },
  {
    path: "/creditCard",
    name: "credit_cards",
    component: CreditCard as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
      page_type: "payment_form",
    },
  },
  {
    path: "/fileAccess",
    name: "file_access",
    component: FileAccess as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
      parent: "backup",
    },
  },
  {
    path: "/creditCard/add",
    name: "add_credit_cards",
    component: AddCreditCard as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: true,
      page_type: "payment_form",
    },
  },
  {
    path: "/paymentHistory",
    name: "payment_history",
    component: PaymentHistory as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    beforeEnter: (to, from, next) => {
      // users who only have subs managed by a reseller cannot access this page
      if (showPaymentHistory()) {
        next();
      } else {
        next({ name: "home" });
      }
    },
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/invoice/:invoiceNumber",
    name: "invoice",
    component: Invoice as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: true,
      hideTitlebar: true,
    },
  },

  {
    path: "/subscriptions",
    name: "subscription_information",
    component: SubscriptionInformation as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/personalInfo",
    name: "personal_information_main",
    component: PersonalInformationRoute as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    children: [
      {
        path: "",
        name: "personal_information",
        component: PersonalInformation as unknown as RouteComponent,
        meta: { parent: "personal_information" },
      },
      {
        path: "addCreditCard",
        name: "add_credit_card",
        component: AddCreditCardFromPersonalInfo as unknown as RouteComponent,
        meta: { parent: "personal_information" },
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/support",
    name: "support",
    component: Support as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/backup",
    name: "backup_main", //We should not be navigating to this route using this Name. If you need to go to back up page use the /backup or name:'backup'
    component: BackupRoute as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    children: [
      { path: "", name: "backup", component: Backup as unknown as RouteComponent, meta: { parent: "backup" } },
      {
        path: "getFilesBack/:deviceId",
        component: GetFilesCdlp as unknown as RouteComponent,
        meta: { parent: "backup" },
      },
      {
        path: "download/:subNumber",
        component: DownloadWebrootTotalProtection as unknown as RouteComponent,
        meta: { parent: "backup" },
      },
      {
        path: "download/:subNumber/:installType",
        component: DownloadWebrootTotalProtection as unknown as RouteComponent,
        meta: { parent: "backup" },
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/buy",
    name: "buy",
    component: Buy as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  //Secondary cart for AB testing
  {
    path: "/buy",
    name: "buyEnhancedCart",
    component: BuyBase as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    //Using Child routes pointed at the same components gives us the ability to go to a new route
    //while keep all the components from mounting again. This is better than the alias because we can keep
    //the query params without any extra code. Since alias count as the same route it will not switch to /review without
    //add a some sort of change to the URL when applied with the same query params
    children: [
      { path: "cart", name: "buyEnhanceCartMain", component: BuyBase as unknown as RouteComponent },
      { path: "review", component: BuyBase as unknown as RouteComponent },
    ],
    //alias: ["/buy/review"],
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/selectPlan",
    name: "selectPlan",
    component: SelectPlan as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/buy/error",
    name: "buy_error",
    component: BuyErrors as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    children: [
      { path: "mismatch", component: FlatRateOfferMismatch as unknown as RouteComponent },
      { path: "expired", component: FlatRateExpiredLicense as unknown as RouteComponent },
      { path: "invalid", component: FlatRateRemainingDaysInvalid as unknown as RouteComponent },
      { path: "unrecoverable", component: SafeLongExpiredComputer as unknown as RouteComponent },
      { path: "upgradeNotAllowed", component: UpgradeNotAllowed as unknown as RouteComponent },
      { path: "cuidRenewalNotAllowed", component: RenewCuidAlreadyPresentForWtpComponent as unknown as RouteComponent },
      {
        path: "optOutTrialError/:errorCode",
        name: "optOutTrialError",
        component: OptOutTrialPurchaseNotAllowed as unknown as RouteComponent,
      },
    ],
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/finalizeAccount",
    name: "finalizeAccount",
    component: FinalizeAccount as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/orderConfirmation",
    name: "orderConfirmation",
    component: OrderConfirmation as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/buy/orderConfirmation",
    name: "orderConfirmationEnhancedCart",
    component: OrderConfirmation as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideProgressbar: true,
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/setNewPassword",
    name: "setNewPassword",
    component: SetNewUserPassword as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: true,
    },
  },
  {
    path: "/downloads",
    name: "downloads",
    component: Downloads as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/windowsArmInfo",
    name: "windowsArmInfo",
    component: WindowsArmInfo as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: false,
      hideSidebar: true,
    },
  },
  {
    path: "/security",
    name: "security",
    component: Security as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/courier",
    name: "courier",
    component: Courier as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/courierRecovery",
    name: "courierRecovery",
    component: CourierRecovery as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/verifyEmail",
    name: "verify_email",
    component: EmailVerification as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
      page_type: "user_form",
    },
  },
  {
    path: "/emailNotVerified",
    name: "email_not_verified",
    component: EmailVerificationIncomplete as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: true,
    },
  },
  {
    path: "/allstateSignUp",
    name: "allstateSignUp",
    component: AllstateSignUp as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/cssbRfa",
    name: "cssb_rfa",
    component: CssbRfa as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: false,
      requireAuth: true,
      allowSmbUser: true,
    },
  },
  {
    path: "/processDownloads",
    name: "cssb_processDownloads",
    component: CssbDownloadWatcher as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      hideTitlebar: true,
      hideFooter: true,
      requireAuth: true,
      allowSmbUser: true,
    },
  },
  {
    path: "/paypalReturn", //Need to update if required to change format to /paypal/return
    component: PayPal as unknown as RouteComponent,
    props: route => ({ ...route.params, redirectTo: "return" }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/paypalCancel", //Need to update if required to change format to /paypal/cancel
    component: PayPal as unknown as RouteComponent,
    props: route => ({ ...route.params, redirectTo: "cancel" }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/paypalNotify", //Need to update if required to change format to /paypal/notify
    component: PayPal as unknown as RouteComponent,
    props: route => ({ ...route.params, redirectTo: "notify" }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/error",
    name: "network_error",
    component: Error as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: false,
      requireAuth: false,
    },
  },
  {
    path: "/underMaintenance",
    name: "underMaintenance",
    component: UnderMaintenance as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/aol",
    name: "createAolAccount",
    component: CreateAolAccountRoute as unknown as RouteComponent,
    children: [
      { path: "createAccount", component: CreateAolAccount as unknown as RouteComponent },
      { path: "addPassword", component: AddPassword as unknown as RouteComponent },
      { path: "preparing", component: PreparingAol as unknown as RouteComponent },
      {
        path: "error",
        children: [
          { path: "tokenApi", component: TokenApiError as unknown as RouteComponent },
          { path: "tokenAlreadyInUse", component: TokenAlreadyInUseError as unknown as RouteComponent },
        ],
      },
    ],
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: true,
      requireAuth: false,
    },
  },
  {
    path: "/MigrateSubscription1xTo2x",
    name: "MigrateSubscription1xTo2x",
    component: MigrateSubscription1xTo2x as unknown as RouteComponent,
    props: route => ({ ...route.params }),
    meta: {
      hideSidebar: false,
      requireAuth: true,
    },
  },
  {
    path: "/ocp/test",
    name: "ocp_test",
    component: OcpTest as unknown as RouteComponent,
    meta: {
      requireAuth: false,
      hideSidebar: true,
      hideTitlebar: true,
      hideFooter: true,
      devOnly: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    component: Unknown as unknown as RouteComponent,
    meta: {
      requireAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

export { routes };

import { useUserStore } from "@/stores/user";
import { UserType } from "@/globalEnums";
import { URLS } from "@/define";
import { pageView } from "@/common/googleTagEvents";
import { useSiteSettingsStore } from "@/stores/siteSettings";
import TokenApiError from "@/components/Aol/AolTokenErrors/TokenApiError.vue";
import TokenAlreadyInUseError from "@/components/Aol/AolTokenErrors/TokenAlreadyInUseError.vue";
import AddPassword from "@/components/Aol/AddPassword.vue";
import CreateAolAccount from "@/components/Aol/CreateAccount.vue";
import PreparingAol from "@/components/Aol/PreparingAol.vue";

// add global navigation guard
router.beforeEach(async to => {
  //Block dev only routes from non dev environments
  if (to.meta?.devOnly && !FLAGS.IS_DEV_MODE) {
    return "/home";
  }

  if (to.query.lang) {
    // the following line repairs an issue where the lang attribute is set more than once in a query string
    // and ends up something like en,en which breaks date formatting in common/dateFormat.ts
    const lang = (to.query.lang as string).split(",")[0];
    localStorage.setItem("selectedLanguage", lang);
    sessionStorage.setItem("langInQuery", "true");
  } else {
    sessionStorage.setItem("langInQuery", "false");
  }
  //do this temporarily because EBS can't change their behavior without a full regression test
  //and we want to get rid of the # in all of our URLs
  if (to.fullPath.indexOf("/#/") >= 0) {
    return to.fullPath.replace("/#/", "/");
  }

  //if we're being sent to error, then just go there.
  //unless we're already there. In that case, try going home
  //which could lead us back here if the issues have not been resolved
  if (to.path === "/error") {
    const isError = localStorage.getItem("isError");
    if (isError == "true") {
      localStorage.setItem("isError", "false");
      return "/home";
    } else {
      localStorage.setItem("isError", "true");
      return true;
    }
  }

  if (to.meta?.requireAuth) {
    const userStore = useUserStore();
    const user = userStore.currentUser;
    const siteSettings = useSiteSettingsStore();
    if (userStore.returnRoute === "") {
      //setting a return path so the original destination is not lost when routing
      // only setting when it's empty so that it saves the first route in the current path
      userStore.returnRoute = to.path;
    }
    if (user) {
      let page_type = "account_page";
      let page_name = "";
      if (to.meta?.page_type) {
        page_type = to.meta.page_type as string;
      }
      if (to.name) {
        page_name = to.name as string;
      }
      pageView(page_name, page_type);
    }

    // check to see if we were routed with the skipLoginLogic param, and if we have a user, we can skip further logic
    if (user && to.params.skipLoginLogic === "true") {
      return true;
    }

    // user has not been set in store, try to load from API
    if (!user) {
      try {
        // required for payment history access
        await reloadSubscriberInfo();
        if (userStore.currentUser) {
          //if this is a smb user and they are attempting to visit a page they are not allowed, send them back to cp login
          if (userStore.userType == UserType.smb && !to.meta?.allowSmbUser) {
            window.location.href = URLS.CP_LOGIN;
          }
        } else return false;
      } catch (err) {
        logEvent("Failed to retrieve user", "router.beforeEach", err);
        return false; // nowhere to go yet...
      }
    }

    //If the user doesn't have a password force them to add one
    if (!userStore.isEstablishedAccount && to.name !== "setNewPassword") {
      return {
        name: "setNewPassword",
      };
    }

    // must be logged in as user response has returned value successfully
    if (siteSettings.getIsCreateAccountFlow() || siteSettings.getSkipAccountSetup()) {
      return true;
    }
    // need to load questions now to check if they are filled out
    try {
      if (!userStore.checkUserSecurityQuestionsFilled && !siteSettings.getIsCreateAccountFlow()) {
        const questions = userStore.currentUser?.subscriberInfo?.securityQuestions;
        if (!questions?.securityQuestionOne || !questions?.securityQuestionTwo || !questions?.securityQuestionThree) {
          userStore.checkUserSecurityQuestionsFilled = false;
          return {
            name: "account_setup",
            params: { skipLoginLogic: "true" },
          };
        } else {
          userStore.checkUserSecurityQuestionsFilled = true;
        }
      } else {
        return true;
      }
    } catch (err) {
      logEvent("Failed to retrieve questions", "router.beforeEach", err);
      return false; // nowhere to go yet...
    }
  } else {
    return true;
  }
});

router.afterEach(async () => {
  if (FLAGS.AUTO_CLOSE_PENDO_TOOLTIP === "true") await removePendoToolTip();
});

export default router;
